module.exports = __webpack_public_path__ + "img/as_register.50d53972.svg";